import type { ReactElement } from "react"
import useTextToBeCopied from "@gatsby-plugin-generic-page/hooks/useTextToBeCopied"
import { Button, Text } from "@ionos-web-design-system/react"
import type { SquidexCopyToClipboardButtonWithText } from "./../../fragments/copyToClipboardButtonWithText"

function CopyToClipboardButtonWithText({
  text,
  textsToBeCopied,
  defaultButtonText,
  buttonIsClickedText,
}: SquidexCopyToClipboardButtonWithText): ReactElement<SquidexCopyToClipboardButtonWithText> {
  const { isButtonClicked, textToCopy, onButtonCLick } =
    useTextToBeCopied(textsToBeCopied)

  return (
    <>
      {text ? (
        <Text variant="bodySm" color="base">
          {text}
        </Text>
      ) : null}

      <Text variant="heading4xl" color="accent" className="m-8!">
        {textToCopy}
      </Text>

      <Button
        title={defaultButtonText}
        onClick={onButtonCLick}
        variant={isButtonClicked ? "secondary" : "primary"}
      >
        {isButtonClicked ? buttonIsClickedText : defaultButtonText}
      </Button>
    </>
  )
}

export default CopyToClipboardButtonWithText
